import classNames from "classnames";

export const ChampionProfilePagePlaceholder = ({ className }: { className?: string }) => {
  return <div className={classNames("rounded-[3px] bg-purple-400 w-full min-h-screen", className)}></div>;
};
